import VueRouter from 'vue-router'
import Vue from 'vue'

import buy from '../components/components/buy'
import download from '../components/components/download'
import productcenter from '../components/components/productcenter'
import productcenterjg from '../components/components/productcenterjg'
import productcenterhq from '../components/components/productcenterhq'
import productcenteryc from '../components/components/productcenteryc'
import productcentertl from '../components/components/productcentertl'
import productcenter1 from '../components/components/productcenter1'
import productcenter2 from '../components/components/productcenter2'
import productcenter3 from '../components/components/productcenter3'
import serive from '../components/components/serive'
// import success from '../components/components/success'
import trade from '../components/components/trade'
import aboveall from '../components/components/aboveall'
import proc from '../components/components/proc'
import shengjishuoming from '../components/components/shengjishuoming'
import succ from '../components/components/succ'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const routes=[

  {
    path:"/aboveall",
    component:aboveall,
    name:"aboveall",
    
  },
  
  {
    path:"/buy/:id",
    component:buy,
    name:"buy"
  },
  {
    path:"/download",
    component:download,
    name:"download"
  },
  {
    path:"/proc",
    component:proc,
    name:"proc",
    children:[
      {
        path:"productcenter/:id",
        component:productcenter,
        name:"productcenter",
      },
      {
        path:"productcenterhq/:id",
        component:productcenterhq,
        name:"productcenterhq",
      },
      {
        path:"productcenteryc/:id",
        component:productcenteryc,
        name:"productcenteryc",
      },
      {
        path:"productcentertl/:id",
        component:productcentertl,
        name:"productcentertl",
      },
      {
        path:"productcenterjg/:id",
        component:productcenterjg,
        name:"productcenterjg",
      },
      {
        path:"productcenter1/:id",
        component:productcenter1,
        name:"productcenter1",
      },
      {
        path:"productcenter2/:id",
        component:productcenter2,
        name:"productcenter2",
      },
      {
        path:"productcenter3/:id",
        component:productcenter3,
        name:"productcenter3",
      },
      {
        path:"shengjishuoming",
        component:shengjishuoming,
        name:"shengjishuoming",
      },
      {
        path:"",
        component:productcenter,
        name:"proc",
      },
    ]
  },
 
  {
    path:"/serive",
    component:serive,
    name:"serive"
  },
  {
    path:"/success",
    component:succ,
    name:"success"
  },
  {
    path:"/trade",
    component:trade,
    name:"trade"
  },
  {path: '*', redirect: '/aboveall'}


]

const router = new VueRouter({
  mode: 'hash',   
 
    routes
  })
export default router